
import React from 'react';
import { Megaphone } from 'lucide-react';
import KitTemplate from '@/components/hq/KitTemplate';

const MarketingKit = () => {
  const sections = {
    downloads: {
      title: "🔹 Downloads",
      description: "Brand assets, templates, and marketing materials",
      files: [
        { name: "Grand Opening Email Templates", type: "docx" as const, size: "3.5 MB", placeholder: true },
        { name: "Social Media Content Pack", type: "pdf" as const, size: "15.2 MB", placeholder: true },
        { name: "Brand Style Guide", type: "pdf" as const, size: "8.7 MB", placeholder: true },
        { name: "Referral Flyer Template", type: "pdf" as const, size: "2.4 MB", placeholder: true }
      ]
    },
    sops: {
      title: "🔸 SOPs",
      description: "Marketing processes and brand standards",
      files: [
        { name: "How to Post to Instagram & TikTok", type: "pdf" as const, placeholder: true },
        { name: "Building Your First Email Campaign", type: "pdf" as const, placeholder: true },
        { name: "Creating a Facebook Ad", type: "pdf" as const, placeholder: true },
        { name: "Managing Launch Promotions", type: "pdf" as const, placeholder: true }
      ]
    },
    training: {
      title: "🎓 Training",
      description: "Marketing education and best practices",
      files: [
        { name: "Running a Grand Opening Campaign", type: "mp4" as const, placeholder: true },
        { name: "How to Use Canva Templates", type: "mp4" as const, placeholder: true },
        { name: "Content Calendar Overview", type: "pdf" as const, placeholder: true }
      ]
    }
  };

  return (
    <KitTemplate
      kitId="marketing"
      kitTitle="Marketing Kit"
      kitDescription="Creative assets, launch campaigns, and brand templates to grow JUV studios"
      icon={<Megaphone className="h-6 w-6 text-purple-400" />}
      sections={sections}
    />
  );
};

export default MarketingKit;
